import * as yup from 'yup'

export const createUserIntegrationSchema = yup.object().shape({
    callback_url: yup.string().url('Введите адрес обратного вызова').required('Введите адрес обратного вызова')
})

export const updateUserIntegrationSchema = yup.object().shape({
    callback_url: yup.string().url('Введите адрес обратного вызова').required('Введите адрес обратного вызова')
})